var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.285 4.72534L14.4574 17.4857L13.8861 14.7379L12.1827 6.39576C12.1827 6.39576 11.9767 4.72534 9.78066 4.72534H1.7997L1.70605 5.03948C1.70605 5.03948 4.14664 5.52383 7.00293 7.16L11.4023 23.2781H16.6784L24.7348 4.72534H19.285Z",
    fill: "#2566AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8866 14.7467L12.1827 6.40357C12.1827 6.40357 11.9767 4.73315 9.78063 4.73315H1.7997L1.70605 5.04729C1.70605 5.04729 5.542 5.80558 9.22134 8.64667C12.7394 11.3622 13.8866 14.7467 13.8866 14.7467Z",
    fill: "#E6A540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaShortLogo);
export default __webpack_public_path__ + "static/media/visa-short-logo.ae071bb7704dbedbe0021839d425ad6b.svg";
export { ForwardRef as ReactComponent };